import { memo } from 'react';
import classnames from 'classnames';
import { OptionCountryProps } from './types';
import s from './index.module.scss';

export const OptionCountry = memo(function OptionCountry(props: OptionCountryProps) {
  const { innerProps, isSelected, data: country } = props;
  return (
    <div {...innerProps} className={classnames(s.option, isSelected && s.option_selected)}>
      <div className={s.flag}>
        <img src={country.flag} alt={country.label} />
      </div>
      <div className={s.name}>{country.label}</div>
    </div>
  );
});